module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/team-registration-report/team-registration-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/team-registration-report/team-registration-report.component.css
// module chunks = main